import {replyChatConvert} from './utilities';

interface ReplyChatSwitcherProps {
  post_reply_type: string;
  chat: UserMessagesResults;
}
const ReplyChatSwitcher = ({post_reply_type, chat}: ReplyChatSwitcherProps) => {
  return replyChatConvert[post_reply_type](chat);
};

export default ReplyChatSwitcher;
